export function cookiePopup() {
    $(window).on("load", function () {
        $("body").focusin(function (e) {
            if (!$(e.target).parents().is("#sliding-popup")) {
                $("#sliding-popup a:first").focus();
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cookiePopup.js